import { downloadBlob } from '../lib/api';

export function downloadProductSummary(growerId, aaids, type) {
  return downloadBlob(`/placement-summary/${growerId}/pdf/${type}`, aaids);
}

export function downloadVPISummary(growerId, aaids) {
  return downloadBlob(`/vpi-summary/${growerId}/pdf/`, aaids);
}
